import React, { useState } from "react";
import { Heading } from "../../../styles/component/style";
import styled from "styled-components";
import theme from "../../../assets/theme";
import {
  Accordion,
  AccordionSummary,
  ExpansionPanel,
  ExpansionPanelSummary,
  makeStyles,
  ExpansionPanelDetails,
} from "@material-ui/core";
import moment from "moment";
import { numberFormat, parseTimeStamp } from "../../../helpers/functions";
import CaseDescriptionModal from "../CaseDescriptionModal";
import AgentListModal from "../AgentListModal/AgentListDrawer";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ClaimItemsListModal from "../../common/ClaimItemsListModal/index";
import CounterClaimModal from "../ClaimItemsListModal/CounterClaim";
import { HyperLink } from "../../../styles/component/style";

const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
    border: "none",
    borderRadius: "8px",
    background: "linear-gradient(135deg, #ffffff 0%, #fafbfc 100%)",
  },
  content: {
    margin: `0 !important`,
    "& .MuiExpansionPanelSummary-content.Mui-expanded": {
      margin: `0 !important`,
    },
  },
  details: {
    display: "flex",
    flexDirection: "column",
    padding: `0 !important`,
  },
}));

const Index = ({ caseDetails, setState, MTRef, setFields, partyList = [] }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);
  const [modal, setModal] = useState();
  // const [type, setType] = useState("");
  const [opendrawer, setOpenDrawer] = useState(false);
  const [opendrawerClaim, setOpenDrawerClaim] = useState(false);
  const [claimModal, setClaimModal] = useState(false);

  const respondentDisplay = () => {
    if (caseDetails?.respondentParty?.name) {
      return caseDetails?.respondentParty?.name;
    }
    if (caseDetails.respondentName) {
      return caseDetails.respondentName;
    }
    if (caseDetails?.respondentParties?.length) {
      return caseDetails?.respondentParties[0]?.name;
    }
    return "";
  };

  const respondentCount = partyList?.filter(
    (el) => el.partyRole === "respondent"
  )?.length;

  return (
    <>
      <ExpansionPanel className={classes.root} expanded={expanded}>
        <ExpansionPanelSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
          classes={{ content: classes.content }}
        >
          <HeaderWrapper>
            {/* LEFT: Title + ID */}
            <CaseTitleSection>
              <CaseTitle>{caseDetails.title}</CaseTitle>
            </CaseTitleSection>

            {/* RIGHT: Actions + Toggle */}
            <RightActions>
              <ToggleButton
                onClick={() => setExpanded((e) => !e)}
                expanded={expanded}
                title={expanded ? "Collapse" : "Expand"}
              >
                {expanded ? "▲" : "▼"}
              </ToggleButton>
            </RightActions>
          </HeaderWrapper>
        </ExpansionPanelSummary>

        <ExpansionPanelDetails className={classes.details}>
          {/* Case Info Grid */}
          <InfoGridContainer>
            <GridRow>
              <InfoCard>
                <InfoLabel>Case ID</InfoLabel>
                <InfoValue>{caseDetails.id}</InfoValue>
              </InfoCard>

              {caseDetails?.resolutionKind === "arbitration" && (
                <InfoCard>
                  <InfoLabel>Contract Number</InfoLabel>
                  <InfoValue>
                    {caseDetails.loanAccountNo
                      ? caseDetails?.loanAccountNo
                      : "-"}
                  </InfoValue>
                </InfoCard>
              )}

              <InfoCard>
                <InfoLabel>Claimant</InfoLabel>
                <InfoValue>{caseDetails?.claimantParty?.name}</InfoValue>
              </InfoCard>

              <InfoCard>
                <InfoLabel>Respondent</InfoLabel>
                <InfoValue>
                  {respondentDisplay()}
                  {respondentCount - 1 > 0 && (
                    <MorePartiesLink
                      onClick={() =>
                        setOpenDrawer((a) => ({ ...a, state: true }))
                      }
                    >
                      +{respondentCount - 1} more
                    </MorePartiesLink>
                  )}
                </InfoValue>
              </InfoCard>
            </GridRow>

            <GridRow>
              <InfoCard>
                <InfoLabel>Claim Value</InfoLabel>
                <InfoValue>
                  {caseDetails.totalClaimValue
                    ? numberFormat(
                        parseFloat(caseDetails.totalClaimValue).toFixed(2),
                        caseDetails?.currencyUnit
                      )
                    : "Non Monetary"}
                  {caseDetails?.resolutionKind === "mediation" &&
                  caseDetails?.caseItems?.length ? (
                    <MorePartiesLink
                      onClick={() =>
                        setOpenDrawerClaim((a) => ({ ...a, state: true }))
                      }
                    >
                      + View Items
                    </MorePartiesLink>
                  ) : (
                    ""
                  )}
                  {caseDetails?.resolutionKind === "arbitration" &&
                  caseDetails?.counterClaimValue !== 0 ? (
                    <MorePartiesLink onClick={() => setClaimModal(true)}>
                      + Counter Claim
                    </MorePartiesLink>
                  ) : null}
                </InfoValue>
              </InfoCard>

              <InfoCard>
                <InfoLabel>Filed on</InfoLabel>
                <InfoValue>
                  {caseDetails.created_at &&
                    moment(parseTimeStamp(caseDetails.created_at)).format(
                      "DD/MM/YYYY"
                    )}
                </InfoValue>
              </InfoCard>

              <InfoCard>
                <InfoLabel>Last Updated</InfoLabel>
                <InfoValue>
                  {caseDetails.updated_at &&
                    moment(parseTimeStamp(caseDetails.updated_at)).format(
                      "DD/MM/YYYY"
                    )}
                </InfoValue>
              </InfoCard>

              {caseDetails?.status !== "draft" && (
                <InfoCard>
                  <InfoLabel>Next Hearing</InfoLabel>
                  <HearingInfo>
                    {caseDetails?.nextHearingDate?.date?.length
                      ? caseDetails?.nextHearingDate?.time
                      : "N/A"}
                  </HearingInfo>
                </InfoCard>
              )}
            </GridRow>

            <ActionButtonsContainer>
              <ActionGroup>
                <HyperLink onClick={() => setState(true)}>
                  Case Documents
                </HyperLink>

                {partyList.length > 0 && (
                  <HyperLink
                    onClick={() =>
                      setOpenDrawer((a) => ({ ...a, state: true }))
                    }
                  >
                    Agent Details
                  </HyperLink>
                )}

                {caseDetails?.resolutionKind === "arbitration" && (
                  <HyperLink onClick={() => setFields(true)}>
                    Case Details
                  </HyperLink>
                )}
              </ActionGroup>
            </ActionButtonsContainer>
          </InfoGridContainer>

          <DescriptionSection>
            <Accordion className={classes.root}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <DescriptionHeading>
                  Case Description
                  {caseDetails?.caseTopic?.length > 0 && (
                    <KeywordsTag>
                      Keywords: {caseDetails.caseTopic.join(", ")}
                    </KeywordsTag>
                  )}
                </DescriptionHeading>
              </AccordionSummary>
              <DescriptionContent>
                {caseDetails?.description}
              </DescriptionContent>
            </Accordion>
          </DescriptionSection>
          {caseDetails?.resolutionKind === "negotiation" && (
            <FooterInfo>
              <FooterItem>
                <FooterLabel>Total Rounds:</FooterLabel>
                <FooterValue>{caseDetails?.negotiationRoundLimit}</FooterValue>
              </FooterItem>
            </FooterInfo>
          )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
      <AgentListModal
        {...{ opendrawer, setOpenDrawer, MTRef, partyList, caseDetails }}
      />
      <ClaimItemsListModal
        {...{
          opendrawerClaim,
          setOpenDrawerClaim,
          MTRef,
          displayAuthUrl: false,
        }}
        caseDetails={caseDetails}
      />
      <CounterClaimModal
        {...{
          claimModal,
          setClaimModal,
          MTRef,
          caseDetails,
        }}
      />
      <CaseDescriptionModal
        {...{ modal, setModal }}
        description={caseDetails?.description}
      />
    </>
  );
};

export default Index;

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  width: 100%;
  gap: 16px;
`;

const CaseTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

const CaseTitle = styled(Heading)`
  margin: 0 !important;
  font-size: 18px !important;
`;

// Right-aligned actions container
const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

const ActionGroup = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 18px;
  align-items: center;
  flex-wrap: nowrap;
`;

const ToggleButton = styled.button`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #293461;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #f7fafc;
  }
`;

const InfoGridContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`;

const InfoCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #cbd5e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transform: translateY(-2px);
  }
`;

const InfoLabel = styled.label`
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #949ab0;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

const InfoValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #293461;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const MorePartiesLink = styled.button`
  background: none;
  border: none;
  color: #00838c;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
  margin-top: 4px;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
  }
`;

const HearingInfo = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  cursor: ${(p) => (p.clickable ? "pointer" : "default")};
  display: flex;
  flex-direction: column;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    color: ${(p) => (p.clickable ? "#00838c" : "#1a202c")};
  }
`;

const DescriptionSection = styled.div`
  padding: 0 24px 24px;
`;

const DescriptionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #293461;
`;

const KeywordsTag = styled.span`
  background: #fef3c7;
  color: #92400e;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-left: 8px;
`;

const DescriptionContent = styled.div`
  font-size: 14px;
  word-break: break-word;
  text-align: justify;
  color: #293461;
  font-family: ${theme.fonts.primaryFontSemiBold};
  padding: 16px;
  background: white;
  border-radius: 6px;
  border-left: 4px solid #00838c;
  max-height: 400px;
  overflow-y: auto;

  & strong,
  & bold {
    font-family: ${theme.fonts.primaryFontExtraBold};
    color: #1a202c;
  }

  & .ql-align-center {
    text-align: center;
  }
  & .ql-align-right {
    text-align: right;
  }
`;

const FooterInfo = styled.div`
  padding: 16px 24px;
  background: #f0f4f8;
  border-top: 1px solid #e2e8f0;
  border-radius: 0 0 8px 8px;
`;

const FooterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FooterLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  color: #718096;
  letter-spacing: 0.5px;
`;

const FooterValue = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1a202c;
`;
